import { useTranslation } from 'react-i18next'
import { getUberBatchStatusClass, getUberBatchStatusLabelKey } from './uberBatchStatus'

export const UberBatchStatusPill = ({ status }) => {
    const { i18n } = useTranslation()
    const className = getUberBatchStatusClass(status)
    const labelKey = getUberBatchStatusLabelKey(status)
    const label = labelKey ? i18n.t(labelKey) : status

    return (
        <span
            data-testid="uber-batch-status-pill"
            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${className}`}
        >
            {label}
        </span>
    )
}
